import { render, staticRenderFns } from "./atlas.vue?vue&type=template&id=f2e26fe0&scoped=true&"
import script from "./atlas.vue?vue&type=script&lang=js&"
export * from "./atlas.vue?vue&type=script&lang=js&"
import style0 from "./atlas.vue?vue&type=style&index=0&id=f2e26fe0&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./atlas.vue?vue&type=style&index=1&id=f2e26fe0&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e26fe0",
  null
  
)

export default component.exports